export default __webpack_public_path__ + "static/media/Fala Kulista.8feebad6.png";